// Every engraved-item and PR box page (src/components/EngravingItemPage.js),
// in the order the services menu lists them. The sitemap, the canonical
// filter, the menu, picture cards and llms.txt read this list.
const itemPages = [
  require('./corporate-gifts'),
  require('./tumblers'),
  require('./coasters-glassware'),
  require('./recognition-awards'),
  require('./bottle-engraving'),
  require('./metal-asset-tags'),
  require('./cutting-boards'),
  require('./metal-business-cards'),
  require('./leather-patch-hats'),
  require('./plaques'),
  require('./advent-calendars'),
  require('./pr-boxes'),
]

const itemPage = Object.fromEntries(itemPages.map((page) => [page.key, page]))

module.exports = { itemPages, itemPage }
